import { authentication } from '@ecosystem/newron-client-lib';
import axios from 'axios';

export enum UserFeedback {
  NONE = 'none',
  LIKE = 'like',
  DISLIKE = 'dislike',
}

export enum FeedbackCategory {
  INACCURATE = 'inaccurate',
  OUT_OF_DATE = 'out of date',
  TOO_SHORT = 'too short',
  HARMFUL_OR_OFFENSIVE = 'harmful or offensive',
  NOT_HELPFUL = 'not helpful',
  TOO_LONG = 'too long',
}

type Feedback = { feedback: UserFeedback; feedbackCategory?: FeedbackCategory; comment?: string };

export async function sendSummaryFeedback(baseUrl: string, requestId: string, feedback: Feedback): Promise<void> {
  const token = await authentication.getAccessToken();
  const response = await axios.patch(`${baseUrl}/${requestId}/feedback`, feedback, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
}
